import React from 'react';
import { FinalCTA, FinalCTAContent, FinalCTAActions } from './CTA.styles';
import PrimaryButton from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { useNavigate } from 'react-router-dom';

const CTA = () => {
  const navigate = useNavigate();

  return (
    <FinalCTA>
      <FinalCTAContent>
        <p className="eyebrowHeader">Need a Safety Manual?</p>

        <h2>Build Documentation That Fits Your Workplace</h2>

        <p>
          Talk with Yoda Safety Services about developing a workplace safety
          manual for your organization and making it available to your team
          online.
        </p>
      </FinalCTAContent>

      <FinalCTAActions>
        <PrimaryButton
          functionName={() => navigate('/contact-us')}
          span="Contact Our Team"
        />
      </FinalCTAActions>
    </FinalCTA>
  );
};

export default CTA;
